import { render, staticRenderFns } from "./AccountComplete.vue?vue&type=template&id=3b66b8ae&"
import script from "./AccountComplete.vue?vue&type=script&lang=js&"
export * from "./AccountComplete.vue?vue&type=script&lang=js&"
import style0 from "./AccountComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports